<template>
  <div id="admin">
    <vue-headful title="Admin" lang="en" />

    <div class="row">
      <div class="col-md-4 col-lg-4 col-xs-12 col-sm-12">
        <h4 class="text-uppercase">Logo</h4>
        <label for="file-upload" class="custom-file-upload">
          <i class="fa fa-cloud-upload"></i> Upload
        </label>
        <input id="file-upload" type="file" class="form-control" :value="f1" @change.prevent.stop="onFileChange($event, 'logotipo')" accept="image/png, image/jpeg">
        <div class="text-center" v-if="logotipo">
          <img :src="'/images/' + logotipo" class="m-h-100" style="max-width:100%" />
          <br />
          <button class="btn btn-pure text-danger m-t-10" @click="apagarIMG(logotipo, 'logotipo')"><i class="fas fa-trash"></i></button>
        </div>
      </div>
      <div class="col-md-4 col-lg-4 col-xs-12 col-sm-12">
        <h4 class="text-uppercase">Backoffice Logo</h4>
        <label for="file-upload1" class="custom-file-upload">
          <i class="fa fa-cloud-upload"></i> Upload
        </label>
        <input id="file-upload1" type="file" class="form-control" :value="f1" @change.prevent.stop="onFileChange($event, 'logotipoBack')" accept="image/png, image/jpeg">
        <div class="text-center" v-if="logotipoBack">
          <img :src="'/images/' + logotipoBack" class="m-h-100" style="max-width:100%" />
          <br />
          <button class="btn btn-pure text-danger m-t-10" @click="apagarIMG(logotipoBack, 'logotipoBack')"><i class="fas fa-trash"></i></button>
        </div>
      </div>
      <div class="col-md-4 col-lg-4 col-xs-12 col-sm-12">
        <h4 class="text-uppercase">FavIcon</h4>
        <label for="file-upload12" class="custom-file-upload">
          <i class="fa fa-cloud-upload"></i> Upload
        </label>
        <input id="file-upload12" type="file" class="form-control" :value="f1" @change.prevent.stop="onFileChange($event, 'favicon')" accept="image/png">
        <div class="text-center" v-if="favicon">
          <img :src="'/images/' + favicon" class="m-h-100" style="max-width:100%" />
          <br />
          <button class="btn btn-pure text-danger m-t-10" @click="apagarIMG(favicon, 'favicon')"><i class="fas fa-trash"></i></button>
        </div>
      </div>
    </div>

    <div class="clearfix"></div><br /><hr /><br />

    <h4 class="text-uppercase">Slider Show</h4>
    <label for="file-upload123" class="custom-file-upload">
      <i class="fa fa-cloud-upload"></i> Upload
    </label>
    <input id="file-upload123" type="file" class="form-control" :value="f1" @change.prevent.stop="onFileChangeSlide($event)" accept="image/png, image/jpeg">
    <div class=" row" v-if="slideshow[0]">
      <div class="float-left text-center p-v-10 col-lg-3 col-md-4 col-sm-6 col-xs-12" v-for="(dt, index) in slideshow" :key="index">
        <img :src="'/images/' + dt" class="float-left m-h-5 m-h-100" style="max-width:100%" />
        <br />
        <button class="btn btn-pure text-danger" @click="apagarSlide(dt, index)"><i class="fas fa-trash"></i></button>
        <div class="clearfix"></div>
      </div>
      <div class="clearfix"></div>
    </div>

    <div class="clearfix"></div><br /><hr /><br />

    <h4 class="text-uppercase">Social Networks</h4>
    <div class="form-group">
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fab fa-youtube"></i></div>
        </div>
        <input v-model="redes.youtube" type="text" class="form-control" placeholder="Youtube">
      </div>
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fab fa-facebook"></i></div>
        </div>
        <input v-model="redes.facebook" type="text" class="form-control" placeholder="FaceBook">
      </div>
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fab fa-twitter"></i></div>
        </div>
        <input v-model="redes.twitter" type="text" class="form-control" placeholder="Twitter">
      </div>
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fab fa-instagram"></i></div>
        </div>
        <input v-model="redes.instagram" type="text" class="form-control" placeholder="Instagram">
      </div>
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fab fa-linkedin-in"></i></div>
        </div>
        <input v-model="redes.linkedin" type="text" class="form-control" placeholder="Linkedin">
      </div>
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fab fa-skype"></i></div>
        </div>
        <input v-model="redes.skype" type="text" class="form-control" placeholder="Skype">
      </div>
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fab fa-whatsapp"></i></div>
        </div>
        <input v-model="redes.whatsapp" type="text" class="form-control" placeholder="WhatsApp">
      </div>
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fab fa-pinterest"></i></div>
        </div>
        <input v-model="redes.pinterest" type="text" class="form-control" placeholder="Pinterest">
      </div>
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fab fa-viber"></i></div>
        </div>
        <input v-model="redes.viber" type="text" class="form-control" placeholder="Viber">
      </div>
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fab fa-reddit"></i></div>
        </div>
        <input v-model="redes.reddit" type="text" class="form-control" placeholder="Reddit">
      </div>
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fab fa-qq"></i></div>
        </div>
        <input v-model="redes.qq" type="text" class="form-control" placeholder="QQ">
      </div>
    </div>
    <button type="button" @click="submitGenericOption('redes')" class="btn btn-primary float-right">SAVE</button>

    <div class="clearfix"></div><br /><hr /><br />

    <h4 class="text-uppercase">Color</h4>
    <sketch-picker @input="upCor" :value="cor" :presetColors="['#c00000', '#ff6600', '#8064a2', '#00b050', '#0070c0', '#996600', '#660066', '#006600', '#ff0066', '#00b0f2', '#9bbb59', '#1f497d', '#333333', '#3333cc', '#4bacc6', '#c0504d']"
    ></sketch-picker>
    <br />
    <button type="button" @click="submitCores" class="btn btn-primary float-right">SAVE</button>

    <div class="clearfix"></div><br /><hr /><br />

    <h4 class="text-uppercase">Currency</h4>
    <div class="form-group">
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fas fa-money-bill"></i></div>
        </div>
        <select v-model="moeda" class="form-control" id="moeda" aria-describedby="">
          <option :value="dt.code" v-for="(dt, index) in moedas" :key="index">{{ dt.name }} ({{ dt.symbol_native }})</option>
        </select>
      </div>
      <!--<small id="googleMapsHelp" class="form-text text-muted" v-html="l('googleMaps2')"></small>-->
    </div>
    <button type="button" @click="submitMoeda" class="btn btn-primary float-right">SAVE</button>

    <div class="clearfix"></div><br /><hr /><br />

    <h4 class="text-uppercase">Google Maps(Api Key)</h4>
    <div class="form-group">
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fas fa-map-marked-alt"></i></div>
        </div>
        <input v-model="googleMaps" type="text" class="form-control" id="googleMaps" aria-describedby="googleMapsHelp" placeholder="">
      </div>
      <!--<small id="googleMapsHelp" class="form-text text-muted" v-html="l('googleMaps2')"></small>-->
    </div>
    <button type="button" @click="submitGenericOption('googleMaps')" class="btn btn-primary float-right">SAVE</button>

    <div class="clearfix"></div><br /><hr /><br />
    <!-- idGoogleAnalytics: this.$store.state.option.idGoogleAnalytics -->
    <!-- <h4 class="text-uppercase">Google</h4> -->
    <div class="form-group">
      <h4 class="text-uppercase">Google Analytics Id</h4>
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fab fa-google"></i></div>
        </div>
        <input v-model="idGoogleAnalytics" type="text" class="form-control" id="GoogleAnalytics" placeholder="Google Analytics Id">
      </div>
    <button type="button" @click="submitGoogleAnalytics('idGoogleAnalytics)')" class="btn btn-primary float-right">SAVE</button>
      <div class="clearfix"></div><br /><hr /><br />
      <h4 class="text-uppercase">Google Clicks' Tracking ID</h4>
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fab fa-google"></i></div>
        </div>
        <input v-model="googleTagPaymentEventId" type="text" class="form-control" id="GoogleTagPaymentEvent" placeholder="Google Clicks' Tracking ID">
      </div>
    <button type="button" @click="submitGenericOption('googleTagPaymentEventId')" class="btn btn-primary float-right">SAVE</button>
      <!-- idGoogleTagManager: this.$store.state.option.idGoogleTagManager -->
      <div class="clearfix"></div><br /><hr /><br />
      <h4 class="text-uppercase">Google tag manager ID</h4>
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fab fa-google"></i></div>
        </div>
        <input v-model="idGoogleTagManager" type="text" class="form-control" id="GoogleTagManager" placeholder="Google Tag Manager Id">
      </div>
      <button type="button" @click="submitGenericOption('idGoogleTagManager')" class="btn btn-primary float-right">SAVE</button>
    </div>
    <br /><br />

    <div class="clearfix"></div><br /><hr /><br />
    <!-- facebookPixelId: this.$store.state.option.facebookPixelId -->
    <h4 class="text-uppercase">Facebook Pixel ID</h4>
    <div class="form-group">
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fab fa-facebook"></i></div>
        </div>
        <input v-model="facebookPixelId" type="text" class="form-control" id="facebookPixelId" placeholder="Facebook Pixel ID">
      </div>
    </div>
    <button type="button" @click="submitGenericOption('facebookPixelId')" class="btn btn-primary float-right">SAVE</button>

    <div class="clearfix"></div><br /><hr /><br />
      <h4 class="text-uppercase">Payment and Reservation Methods</h4>
        <div class="form-group col-md-12 col-lg-12">
          <div class="form-check">
            <input v-model="paymentMethodsOption.showPaypalOption" type="checkbox" class="form-check-input" id="showPaypalOption">
            <label class="form-check-label" for="showPaypalOption">PayPal</label>
          </div>
        </div>
        <div class="form-group col-md-12 col-lg-12">
          <div class="form-check">
            <input v-model="paymentMethodsOption.showReserveWithCardOption" type="checkbox" class="form-check-input" id="showReserveWithCardOption">
            <label class="form-check-label" for="showReserveWithCardOption">Confirm With Credit Card</label>
          </div>
        </div>
        <div class="form-group col-md-12 col-lg-12">
          <div class="form-check">
            <input v-model="paymentMethodsOption.showPayWithCreditCardOtpion" type="checkbox" class="form-check-input" id="showPayWithCreditCardOtpion" :disabled="!Number(this.$store.state.option.optionalModuleUnicre)">
            <label class="form-check-label" for="showPayWithCreditCardOtpion">Online Payment with Credit Card</label>
          </div>
      </div>
    <button type="button" @click="submitGenericOption('paymentMethodsOption')" class="btn btn-primary float-right">SAVE</button>

    <div class="clearfix"></div><br /><hr /><br />
    <h4 class="text-uppercase">Paypal</h4>
    <div class="form-group">
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text">Client ID</div>
        </div>
        <input v-model="paypal.paypal_client_id" type="text" class="form-control" id="paypal_client_id" placeholder="">
      </div>
    </div>
    <div class="form-group">
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text">API Credentials</div>
        </div>
        <input v-model="paypal.paypal_secret" type="password" class="form-control" id="paypal_secret" aria-describedby="paypal_secretHelp" placeholder="Type to change">
        <span v-if="$store.state.option.paypal_secret_isset" class="input-group-text text-success" title="A value is currently set">&#10003; Set</span>
      </div>
      <div class="form-check">
        <input v-model="paypal.paypal_live" type="checkbox" class="form-check-input" id="paypal_live">
        <label class="form-check-label" for="paypal_live">Paypal Live</label>
      </div>
      <small id="paypal_secretHelp" class="form-text text-muted">
        <pre>
          Log in to your PayPal account.
          Click here to go to PayPal Developer Applications.
          Scroll down to Rest API apps and click the "Create App" button.
          Enter an App Name.
          Click "Create App."
          Click on the "Live" tab to view the live API Credentials.
          Scroll down and click "Show" under Secret.
        </pre>
      </small>
    </div>
    <button type="button" @click="submitGenericOption('paypal')" class="btn btn-primary float-right">SAVE</button>

    <div class="clearfix"></div><br /><hr /><br />
        <h4 class="text-uppercase">Accepted Credit Card for Confirmation</h4>
        <div class="form-group col-md-12 col-lg-12">
          <div class="form-check">
            <input v-model="cardPaymentMethods.americanExpress" type="checkbox" class="form-check-input" id="americanExpress">
            <label class="form-check-label" for="americanExpress">American Express</label>
          </div>
        </div>
        <div class="form-group col-md-12 col-lg-12">
          <div class="form-check">
            <input v-model="cardPaymentMethods.dinersClub" type="checkbox" class="form-check-input" id="dinersClub">
            <label class="form-check-label" for="dinersClub">Diners Club</label>
          </div>
      </div>
    <button type="button" @click="submitGenericOption('cardPaymentMethods')" class="btn btn-primary float-right">SAVE</button>

    <div class="clearfix"></div><br /><hr /><br />

    <h4 class="text-uppercase">SMTP EMAIL</h4>
    <div class="row">
      <div class="form-group col-md-6 col-lg-6">
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text">Username</div>
          </div>
          <input v-model="email.e_username" type="password" class="form-control" placeholder="Type to change">
          <span v-if="$store.state.option.e_username_isset" class="input-group-text text-success" title="A value is currently set">&#10003; Set</span>
        </div>
      </div>
      <div class="form-group col-md-6 col-lg-6">
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text">Email</div>
          </div>
          <input v-model="email.e_email" type="text" class="form-control" placeholder="">
        </div>
      </div>
      <div class="form-group col-md-6 col-lg-6">
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text">Password</div>
          </div>
          <input v-model="email.e_password" type="password" class="form-control" placeholder="Type to change">
          <span v-if="$store.state.option.e_password_isset" class="input-group-text text-success" title="A value is currently set">&#10003; Set</span>
        </div>
      </div>
      <div class="form-group col-md-6 col-lg-6">
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text">Name</div>
          </div>
          <input v-model="email.e_name" type="text" class="form-control" placeholder="">
        </div>
      </div>
      <div class="form-group col-md-6 col-lg-6">
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text">Port</div>
          </div>
          <input v-model="email.e_port" type="text" class="form-control" placeholder="">
        </div>
      </div>
      <div class="form-group col-md-6 col-lg-6">
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text">Security</div>
          </div>
          <input v-model="email.e_security" type="text" class="form-control" placeholder="">
        </div>
      </div>
      <div class="form-group col-md-6 col-lg-6">
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text">Hostname</div>
          </div>
          <input v-model="email.e_hostname" type="text" class="form-control" placeholder="">
        </div>
      </div>
    </div>
    <button type="button" @click="submitGenericOption('email')" class="btn btn-primary float-right">SAVE</button>

    <div class="clearfix"></div><br /><hr /><br />

    <h4 class="text-uppercase">Company</h4>
    <div class="row">
      <div class="form-group col-md-6 col-lg-6">
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text">Company Code</div>
          </div>
          <input v-model="dta.company" type="text" class="form-control" placeholder="">
        </div>
      </div>
      <div class="form-group col-md-6 col-lg-6">
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text">Customer Code</div>
          </div>
          <input v-model="dta.customer" type="text" class="form-control" placeholder="">
        </div>
      </div>

      <div class="form-group col-md-6 col-lg-6">
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text">Super Username</div>
          </div>
          <input v-model="dta.super_username" type="password" class="form-control" placeholder="Type to change">
          <span v-if="$store.state.option.super_username_isset" class="input-group-text text-success" title="A value is currently set">&#10003; Set</span>
        </div>
      </div>
      <div class="form-group col-md-6 col-lg-6">
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text">Super Password</div>
          </div>
          <input v-model="dta.super_password" type="password" class="form-control" placeholder="Type to change">
          <span v-if="$store.state.option.super_password_isset" class="input-group-text text-success" title="A value is currently set">&#10003; Set</span>
        </div>
      </div>

      <div class="form-group col-md-6 col-lg-6">
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text">Client</div>
          </div>
          <input v-model="dta.client" type="password" class="form-control" placeholder="Type to change">
          <span v-if="$store.state.option.client_isset" class="input-group-text text-success" title="A value is currently set">&#10003; Set</span>
        </div>
      </div>
      <div class="form-group col-md-6 col-lg-6">
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text">Client Password</div>
          </div>
          <input v-model="dta.client_password" type="password" class="form-control" placeholder="Type to change">
          <span v-if="$store.state.option.client_password_isset" class="input-group-text text-success" title="A value is currently set">&#10003; Set</span>
        </div>
      </div>
    </div>
    <button type="button" @click="submitGenericOption('dta')" class="btn btn-primary float-right">SAVE</button>

    <div class="clearfix"></div><br /><hr /><br />
    <div class="row">
      <div class="col-md-6 col-lg-6 col-sm-6 col-xs-12">
        <h4 class="text-uppercase">Mandatory Fields To Be Filled To Register The Driver</h4>
        <div class="form-group col-md-12 col-lg-12">
          <div class="form-check">
            <input v-model="reg.address_register" type="checkbox" class="form-check-input" id="address_register">
            <label class="form-check-label" for="address_register">Address</label>
          </div>
        </div>
        <div class="form-group col-md-12 col-lg-12">
          <div class="form-check">
            <input v-model="reg.postal_Code_register" type="checkbox" class="form-check-input" id="postal_Code_register">
            <label class="form-check-label" for="postal_Code_register">Postal Code</label>
          </div>
        </div>
        <div class="form-group col-md-12 col-lg-12">
          <div class="form-check">
            <input v-model="reg.city_register" type="checkbox" class="form-check-input" id="city_register">
            <label class="form-check-label" for="city_register">City</label>
          </div>
        </div>

        <div class="form-group col-md-12 col-lg-12">
          <div class="form-check">
            <input v-model="reg.document_type_register" type="checkbox" class="form-check-input" id="document_type_register">
            <label class="form-check-label" for="document_type_register">Document Type</label>
          </div>
        </div>
        <div class="form-group col-md-12 col-lg-12">
          <div class="form-check">
            <input v-model="reg.document_number_register" type="checkbox" class="form-check-input" id="document_number_register">
            <label class="form-check-label" for="document_number_register">Document Number</label>
          </div>
        </div>
        <div class="form-group col-md-12 col-lg-12">
          <div class="form-check">
            <input v-model="reg.document_Place_register" type="checkbox" class="form-check-input" id="document_Place_register">
            <label class="form-check-label" for="document_Place_register">Document Place</label>
          </div>
        </div>
        <div class="form-group col-md-12 col-lg-12">
          <div class="form-check">
            <input v-model="reg.license_Number_register" type="checkbox" class="form-check-input" id="license_Number_register">
            <label class="form-check-label" for="license_Number_register">Licence Number</label>
          </div>
        </div>
        <div class="form-group col-md-12 col-lg-12">
          <div class="form-check">
            <input v-model="reg.license_Country_register" type="checkbox" class="form-check-input" id="license_Country_register">
            <label class="form-check-label" for="license_Country_register">Licence Country</label>
          </div>
        </div>

        <div class="form-group col-md-12 col-lg-12">
          <div class="form-check">
            <input v-model="reg.phone_Number_register" type="checkbox" class="form-check-input" id="phone_Number_register">
            <label class="form-check-label" for="phone_Number_register">Phone Number</label>
          </div>
        </div>
        <div class="form-group col-md-12 col-lg-12">
          <div class="form-check">
            <input v-model="reg.mobile_Number_register" type="checkbox" class="form-check-input" id="mobile_Number_register">
            <label class="form-check-label" for="mobile_Number_register">Mobile Number</label>
          </div>
        </div>

        <div class="form-group col-md-12 col-lg-12">
          <div class="form-check">
            <input v-model="reg.email_Notification_register" type="checkbox" class="form-check-input" id="email_Notification_register">
            <label class="form-check-label" for="email_Notification_register">Email Notification</label>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-6 col-sm-6 col-xs-12">
        <h4 class="text-uppercase">Mandatory Fields To Be Filled By The Guest</h4>
        <div class="form-group col-md-12 col-lg-12">
          <div class="form-check">
            <input v-model="reg.address_register1" type="checkbox" class="form-check-input" id="address_register1">
            <label class="form-check-label" for="address_register1">Address</label>
          </div>
        </div>
        <div class="form-group col-md-12 col-lg-12">
          <div class="form-check">
            <input v-model="reg.postal_Code_register1" type="checkbox" class="form-check-input" id="postal_Code_register1">
            <label class="form-check-label" for="postal_Code_register1">Postal Code</label>
          </div>
        </div>
        <div class="form-group col-md-12 col-lg-12">
          <div class="form-check">
            <input v-model="reg.city_register1" type="checkbox" class="form-check-input" id="city_register1">
            <label class="form-check-label" for="city_register1">City</label>
          </div>
        </div>
        <div class="form-group col-md-12 col-lg-12">
          <div class="form-check">
            <input v-model="reg.country1" type="checkbox" class="form-check-input" id="country1">
            <label class="form-check-label" for="country1">Country</label>
          </div>
        </div>

        <div class="form-group col-md-12 col-lg-12">
          <div class="form-check">
            <input v-model="reg.idNumber1" type="checkbox" class="form-check-input" id="idNumber1">
            <label class="form-check-label" for="idNumber1">Id Number</label>
          </div>
        </div>

        <div class="form-group col-md-12 col-lg-12">
          <div class="form-check">
            <input v-model="reg.passportNumber1" type="checkbox" class="form-check-input" id="passportNumber1">
            <label class="form-check-label" for="passportNumber1">Passport Number</label>
          </div>
        </div>
        <div class="form-group col-md-12 col-lg-12">
          <div class="form-check">
            <input v-model="reg.license_Number_register1" type="checkbox" class="form-check-input" id="license_Number_register1">
            <label class="form-check-label" for="license_Number_register1">Licence Number</label>
          </div>
        </div>
        <div class="form-group col-md-12 col-lg-12">
          <div class="form-check">
            <input v-model="reg.taxNumber1" type="checkbox" class="form-check-input" id="taxNumber1">
            <label class="form-check-label" for="taxNumber1">Tax Number</label>
          </div>
        </div>

        <div class="form-group col-md-12 col-lg-12">
          <div class="form-check">
            <input v-model="reg.phone_Number_register1" type="checkbox" class="form-check-input" id="phone_Number_register1">
            <label class="form-check-label" for="phone_Number_register1">Phone Number</label>
          </div>
        </div>
        <div class="form-group col-md-12 col-lg-12">
          <div class="form-check">
            <input v-model="reg.mobile_Number_register1" type="checkbox" class="form-check-input" id="mobile_Number_register1">
            <label class="form-check-label" for="mobile_Number_register1">Mobile Number</label>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group col-md-6 col-lg-6">
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text">Minimum age</div>
          </div>
          <input v-model="reg.idade_minima" type="text" class="form-control" placeholder="">
        </div>
    </div>
    <button type="button" @click="submitGenericOption('reg')" class="btn btn-primary float-right">SAVE</button>

    <div class="clearfix"></div><br /><hr /><br />

    <h4 class="text-uppercase">Tax, Vat</h4>
    <div class="row">
      <div class="form-group col-md-12 col-lg-12">
        <div class="form-check">
          <input v-model="iva.iva" type="checkbox" class="form-check-input" id="iva">
          <label class="form-check-label" for="iva">Price with VAT</label>
        </div>
      </div>
      <div class="form-group col-md-6 col-lg-6">
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text">Tax Name</div>
          </div>
          <input v-model="iva.name_iva" type="text" class="form-control" placeholder="">
        </div>
      </div>
    </div>
    <button type="button" @click="submitGenericOption('iva')" class="btn btn-primary float-right">SAVE</button>
    <div class="clearfix"></div><br /><hr /><br />

    <h4 class="text-uppercase">Dates Configuration</h4>
    <div class="p-l-10">
      <div>
        <input type="radio" v-model="dateConfigValue" value="US" id="us" @change="setDatesConfiguration($event)">
        <label for="us">US (YYYY-MM-DD)</label>
      </div>
      <div>
        <input type="radio" v-model="dateConfigValue" value="EU" id="eu" @change="setDatesConfiguration($event)">
        <label for="eu">EU (DD-MM-YYYY)</label>
      </div>
    </div>
    <button type="button" @click="submitGenericOption('dateConfigValue')" class="btn btn-primary float-right">SAVE</button>

    <div class="clearfix"></div><br /><hr /><br />
    <h4 class="text-uppercase">META Configuration</h4>
    <div class="form-group">
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text">Meta Title</div>
        </div>
        <input v-model="metaData.metaTitle" type="text" class="form-control" id="metaTitle" placeholder="Meta Title">
      </div>
    </div>
    <div class="form-group">
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text">Meta Description</div>
        </div>
        <input v-model="metaData.metaDescription" type="text" class="form-control" id="metaDescription" placeholder="Meta Description">
      </div>
    </div>
    <div class="form-group">
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text">Meta Keywords</div>
        </div>
        <input v-model="metaData.metaKeywords" type="text" class="form-control" id="metaKeywords" placeholder="Meta Keywords">
      </div>
    </div>
    <button type="button" @click="submitGenericOption('metaData')" class="btn btn-primary float-right">SAVE</button>

  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { Sketch } from 'vue-color'
import MOEDAS from './../components/moedas.json'

const SECRET_SET = '••••••••'

export default {
  name: 'admin',
  components: { 'sketch-picker': Sketch },
  data () {
    return {
      logotipo: '',
      logotipoBack: '',
      favicon: '',
      slideshow: [],
      redes: {
        youtube: '',
        facebook: '',
        twitter: '',
        instagram: '',
        linkedin: '',
        skype: '',
        whatsapp: '',
        pinterest: '',
        viber: '',
        reddit: '',
        qq: ''
      },
      paymentMethodsOption: {
        showPaypalOption: '',
        showReserveWithCardOption: '',
        showPayWithCreditCardOtpion: ''
      },
      paypal: {
        paypal_client_id: '',
        paypal_secret: null,
        paypal_live: false
      },
      cardPaymentMethods: {
        americanExpress: false,
        dinersClub: false
      },
      email: {
        e_username: null,
        e_email: '',
        e_hostname: '',
        e_port: '',
        e_password: null,
        e_name: '',
        e_security: ''
      },
      dta: {
        company: '',
        customer: '',
        super_password: null,
        super_username: null,
        client: null,
        client_password: null
      },
      cor: { hex: '#ff6600' },
      f1: '',
      googleMaps: '',
      idGoogleAnalytics: '',
      idGoogleTagManager: '',
      googleTagPaymentEventId: '',
      facebookPixelId: '',
      moeda: '',
      moedas: MOEDAS,
      reg: {
        document_type_register: false,
        document_number_register: false,
        license_Number_register: false,
        license_Country_register: false,
        email_Notification_register: false,
        address_register: false,
        postal_Code_register: false,
        city_register: false,
        document_Place_register: false,
        phone_Number_register: false,
        mobile_Number_register: false,
        idade_minima: 18,

        address_register1: false,
        postal_Code_register1: false,
        city_register1: false,
        phone_Number_register1: false,
        mobile_Number_register1: false,
        country1: false,
        idNumber1: false,
        passportNumber1: false,
        license_Number_register1: false,
        taxNumber1: false
      },
      iva: {
        iva: false,
        name_iva: ''
      },
      dateConfigValue: 'US',
      datesConfiguration: {
        date_mask: '####-##-##',
        date_format: 'YYYY-MM-DD'
      },
      metaData: {
        metaTitle: '',
        metaDescription: '',
        metaKeywords: ''
      }
    }
  },
  mounted () {
    this.SET_LOAD(true)
    this.SET_TITULO('Dashboard')
    this.init()
  },
  methods: {
    ...mapMutations([
      'SET_TITULO',
      'SET_LOAD',
      'SET_TOAST',
      'SET_AVISO',
      'SET_OPTIONS',
      'SET_LOAD1'
    ]),
    init () {
      if (this.$store.state.option1 && this.$store.state.user1) {
        if (!(this.$store.state.user.role)) {
          this.$router.push('/', () => {})
          return
        }
        this.logotipo = this.$store.state.option.logotipo || ''
        this.logotipoBack = this.$store.state.option.logotipoBack || ''
        this.favicon = this.$store.state.option.favicon || ''
        this.slideshow = this.$store.state.option.slideshow ? this.$store.state.option.slideshow.split('##') : []
        this.cor = { hex: this.$store.state.option.cor || '#ff6600' }
        this.googleMaps = this.$store.state.option.googleMaps
        this.idGoogleAnalytics = this.$store.state.option.idGoogleAnalytics
        this.idGoogleTagManager = this.$store.state.option.idGoogleTagManager
        this.googleTagPaymentEventId = this.$store.state.option.googleTagPaymentEventId
        this.facebookPixelId = this.$store.state.option.facebookPixelId
        this.moeda = this.$store.state.option.moeda || 'EUR'
        this.redes = {
          youtube: this.$store.state.option.youtube || '',
          facebook: this.$store.state.option.facebook || '',
          twitter: this.$store.state.option.twitter || '',
          instagram: this.$store.state.option.instagram || '',
          linkedin: this.$store.state.option.linkedin || '',
          skype: this.$store.state.option.skype || '',
          whatsapp: this.$store.state.option.whatsapp || '',
          pinterest: this.$store.state.option.pinterest || '',
          viber: this.$store.state.option.viber || '',
          reddit: this.$store.state.option.reddit || '',
          qq: this.$store.state.option.qq || ''
        }
        this.paymentMethodsOption = {
          showPaypalOption: Boolean(Number(this.$store.state.option.showPaypalOption)),
          showReserveWithCardOption: Boolean(Number(this.$store.state.option.showReserveWithCardOption)),
          showPayWithCreditCardOtpion: Boolean(Number(this.$store.state.option.showPayWithCreditCardOtpion))
        }
        this.paypal = {
          paypal_client_id: this.$store.state.option.paypal_client_id,
          paypal_secret: this.$store.state.option.paypal_secret_isset ? SECRET_SET : null,
          paypal_live: this.$store.state.option.paypal_live > 0 ? 1 : 0
        }
        this.cardPaymentMethods = {
          americanExpress: Boolean(Number(this.$store.state.option.americanExpress)),
          dinersClub: Boolean(Number(this.$store.state.option.dinersClub))
        }
        this.email = {
          e_username: this.$store.state.option.e_username_isset ? SECRET_SET : null,
          e_email: this.$store.state.option.e_email,
          e_hostname: this.$store.state.option.e_hostname,
          e_port: this.$store.state.option.e_port,
          e_password: this.$store.state.option.e_password_isset ? SECRET_SET : null,
          e_name: this.$store.state.option.e_name,
          e_security: this.$store.state.option.e_security
        }
        this.dta = {
          company: this.$store.state.option.company,
          customer: this.$store.state.option.customer,
          super_password: this.$store.state.option.super_password_isset ? SECRET_SET : null,
          super_username: this.$store.state.option.super_username_isset ? SECRET_SET : null,
          client: this.$store.state.option.client_isset ? SECRET_SET : null,
          client_password: this.$store.state.option.client_password_isset ? SECRET_SET : null
        }
        this.reg = {
          document_type_register: this.$store.state.option.document_type_register > 0 ? 1 : 0,
          document_number_register: this.$store.state.option.document_number_register > 0 ? 1 : 0,
          license_Number_register: this.$store.state.option.license_Number_register > 0 ? 1 : 0,
          license_Country_register: this.$store.state.option.license_Country_register > 0 ? 1 : 0,
          email_Notification_register: this.$store.state.option.email_Notification_register > 0 ? 1 : 0,
          address_register: this.$store.state.option.address_register > 0 ? 1 : 0,
          postal_Code_register: this.$store.state.option.postal_Code_register > 0 ? 1 : 0,
          city_register: this.$store.state.option.city_register > 0 ? 1 : 0,
          document_Place_register: this.$store.state.option.document_Place_register > 0 ? 1 : 0,
          phone_Number_register: this.$store.state.option.phone_Number_register > 0 ? 1 : 0,
          mobile_Number_register: this.$store.state.option.mobile_Number_register > 0 ? 1 : 0,
          idade_minima: this.$store.state.option.idade_minima > 0 ? this.$store.state.option.idade_minima : 0,
          license_Number_register1: this.$store.state.option.license_Number_register1 > 0 ? 1 : 0,
          address_register1: this.$store.state.option.address_register1 > 0 ? 1 : 0,
          postal_Code_register1: this.$store.state.option.postal_Code_register1 > 0 ? 1 : 0,
          city_register1: this.$store.state.option.city_register1 > 0 ? 1 : 0,
          phone_Number_register1: this.$store.state.option.phone_Number_register1 > 0 ? 1 : 0,
          mobile_Number_register1: this.$store.state.option.mobile_Number_register1 > 0 ? 1 : 0,
          country1: this.$store.state.option.country1 > 0 ? 1 : 0,
          idNumber1: this.$store.state.option.idNumber1 > 0 ? 1 : 0,
          passportNumber1: this.$store.state.option.passportNumber1 > 0 ? 1 : 0,
          taxNumber1: this.$store.state.option.taxNumber1 > 0 ? 1 : 0
        }
        this.iva = {
          iva: this.$store.state.option.iva > 0 ? 1 : 0,
          name_iva: this.$store.state.option.name_iva
        }
        this.setDatesConfiguration('init')
        this.setMetaConfiguration()
        this.SET_LOAD()
      } else {
        this._.delay(this.init, 100)
      }
    },
    // imagens
    onFileChange (e, name) {
      this.SET_LOAD1(true)
      e.preventDefault()
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      this.f1 = ''
      let data = new window.FormData()
      data.append('image', files[0])
      if (name === 'favicon') {
        data.append('favicon', true)
      }
      this.axios.post('/multimedia', data).then((res) => {
        this[name] = res.data.image
        data = {}
        data[name] = this[name]
        this.axios.post('/options', data).then((res) => {
          this.SET_LOAD1()
          this.SET_OPTIONS(res.data)
        }, (er) => {
          this.SET_AVISO(er.response.data.error)
        })
      }, (er) => {
        this.SET_AVISO(er.response.data.error)
      })
    },
    apagarIMG (src, name) {
      this.SET_LOAD1(true)
      this.axios.delete('/multimedia/' + src).then((res) => {
        this.axios.post('/options', { nome: '' }).then((res) => {
          this[name] = ''
          this.SET_LOAD1()
          this.SET_OPTIONS(res.data)
        }, (er) => {
          this.SET_AVISO(er.response.data.error)
        })
      }, (er) => {
        this.SET_AVISO(er.response.data.error)
      })
    },
    // slideshow
    onFileChangeSlide (e) {
      this.SET_LOAD1(true)
      e.preventDefault()
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      this.f2 = ''
      let data = new window.FormData()
      data.append('image', files[0])
      this.axios.post('/multimedia', data).then((res) => {
        this.slideshow.push(res.data.image)
        this.axios.post('/options', { 'slideshow': this.slideshow.join('##') }).then((res) => {
          this.SET_LOAD1()
          this.SET_OPTIONS(res.data)
        }, (er) => {
          this.SET_AVISO(er.response.data.error)
        })
      }, (er) => {
        this.SET_AVISO(er.response.data.error)
      })
    },
    apagarSlide (src, index) {
      this.SET_LOAD1(true)
      this.slideshow.splice(index, 1)
      this.axios.post('/options', { 'slideshow': this.slideshow.join('##') }).then((res) => {
        this.SET_LOAD1()
        this.SET_OPTIONS(res.data)
      }, (er) => {
        this.SET_AVISO(er.response.data.error)
      })
    },
    // cores
    upCor (a) {
      this.cor = a
    },

    submit (payload, callback = null) {
      this.SET_LOAD1(true)
      const filtered = Object.fromEntries(Object.entries(payload).filter(([, v]) => v !== null && v !== SECRET_SET))
      this.axios.post('/options', filtered)
        .then(response => {
          this.SET_TOAST({ msg: 'Updated successfully' })
          this.SET_OPTIONS(response.data)
          if (callback) callback()
        })
        .catch(error => {
          this.SET_AVISO(error.response.data.error || 'An error occurred')
        })
        .finally(() => {
          this.SET_LOAD1(false)
        })
    },

    submitCores () {
      this.submit({ cor: this.cor.hex }, () => {
        document.getElementById('css').innerHTML = `<style type="text/css">
          .laranja, .vueperslides__arrow--prev, .vueperslides__arrow--next, 
          .menu-link-top:hover, a, .mx-panel-date td.today {color: ${this.cor.hex};}
          .b-laranja, .active, .btn-primary, ul.pagination>li.page-item>a.page-link, 
          .btn-primary:active, .mx-calendar-content .cell.actived {background: ${this.cor.hex} !important;}
          .btn-primary, .btn-primary:active, ul.pagination>li.page-item>a.page-link {border-color: ${this.cor.hex};}
          .bordaSearch {border-color: ${this.cor.hex} !important;}
        </style>`
      })
    },

    submitMoeda () {
      const simb = this.moedas.find(a => a.code === this.moeda).symbol
      this.submit({ moeda: this.moeda, moeda1: simb })
    },

    submitGoogleAnalytics () {
      this.submitGenericOption('idGoogleAnalytics', {
        googleTagPaymentEventId: this.googleTagPaymentEventId,
        idGoogleTagManager: this.idGoogleTagManager
      })
    },

    submitGenericOption (optionKey, extraPayload = {}) {
      this.submit({ ...extraPayload, ...this[optionKey] })
    },

    setDatesConfiguration (e) {
      if (e === 'init') {
        this.datesConfiguration.date_mask = this.$store.state.option.date_mask
        this.datesConfiguration.date_format = this.$store.state.option.date_format
        this.dateConfigValue = this.$store.state.option.date_format === 'YYYY-MM-DD' ? 'US' : 'EU'
      } else if (e.target.value === 'US') {
        this.datesConfiguration.date_mask = '####-##-##'
        this.datesConfiguration.date_format = 'YYYY-MM-DD'
      } else if (e.target.value === 'EU') {
        this.datesConfiguration.date_mask = '##-##-####'
        this.datesConfiguration.date_format = 'DD-MM-YYYY'
      }
    },
    setMetaConfiguration () {
      this.metaData.metaTitle = this.$store.state.option.metaTitle
      this.metaData.metaDescription = this.$store.state.option.metaDescription
      this.metaData.metaKeywords = this.$store.state.option.metaKeywords
    }
  }
}
</script>
